export type Msg = {
  role: "user" | "assistant";
  content: string;
  thinking?: string;
  truncated?: boolean;
};


export type Session = {
  id: string;
  title: string;
  updatedAt: number;
  model?: string;
  messages: Msg[];
  /** Compressed earlier context injected as system on API calls */
  summary?: string;
  /** How many leading messages are covered by `summary` */
  summarizedCount?: number;
};

const KEY = "echollm_sessions_v1";

function uid(): string {
  return `${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 8)}`;
}

export function sessionTitle(msgs: Msg[]): string {
  const first = msgs.find((m) => m.role === "user" && m.content);
  if (!first) return "New chat";
  let t = String(first.content)
    .replace(/```[\s\S]*?```/g, " ")
    .replace(/```[\s\S]*$/g, " ")
    .replace(/\s+/g, " ")
    .trim();
  if (!t || /^(#include|\/\*|\/\/|#define|using |typedef |int main|class )/i.test(t)) {
    const when = new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
    return `Code @ ${when}`;
  }
  if (t.length > 28) t = t.slice(0, 28) + "…";
  return t;
}

export function loadSessions(): Session[] {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const data = JSON.parse(raw) as Session[];
    return Array.isArray(data) ? data : [];
  } catch {
    return [];
  }
}

export function saveSessions(sessions: Session[]): void {
  localStorage.setItem(KEY, JSON.stringify(sessions));
}

export function createSession(model?: string): Session {
  return {
    id: uid(),
    title: "New chat",
    updatedAt: Date.now(),
    model,
    messages: [],
    summary: undefined,
    summarizedCount: 0,
  };
}

export function exportSession(s: Session): string {
  const lines = s.messages.map((m) => `## ${m.role}\n\n${m.content}`).join("\n\n---\n\n");
  return `# ${s.title}\n\n${lines}\n`;
}
